import { ArrowUpRight } from "lucide-react";
import { Badge, DropdownMenuItem } from "web-design-system";
import { getCORSSafeURL } from "@/utils/url";
import { AvatarEmployee } from "web-core";
import AppLogo from "../logo/app-logo";

type EmployeeAccountSettingsSectionProps = {
  personName: string;
  isEmployeeRole: boolean;
  organizationLine: string;
  brandingLogo?: string | null;
  onOpenAccountDetails: () => void;
  getInitials: (name: string) => string;
};

export function EmployeeAccountSettingsSection({
  personName,
  isEmployeeRole,
  organizationLine,
  brandingLogo,
  onOpenAccountDetails,
  getInitials,
}: EmployeeAccountSettingsSectionProps) {
  return (
    <div className="relative border-b border-border px-4 py-5 text-center">
      <DropdownMenuItem
        className="absolute right-2 top-2 flex cursor-pointer items-center justify-center rounded-sm bg-background border border-border shadow-xs px-2 py-2"
        onSelect={onOpenAccountDetails}
        aria-label="Account details"
      >
        <ArrowUpRight className="size-4" />
      </DropdownMenuItem>
      <div className="flex flex-col items-center gap-3 px-6 pt-2 text-center">
        <AvatarEmployee fallback={getInitials(personName)} size="sm" />
        <p className="line-clamp-2 w-full text-sm font-semibold text-foreground">
          {personName}
        </p>
        <Badge
          variant="custom"
          className={
            isEmployeeRole
              ? "rounded-sm bg-tag-slate text-tag-slate-foreground"
              : "rounded-sm bg-tag-violet text-tag-violet-foreground"
          }
        >
          {isEmployeeRole ? "Employee" : "Admin"}
        </Badge>
        <div className="flex items-center gap-2 rounded-sm bg-tag-slate px-3 py-2">
          <div className="flex shrink-0 items-center justify-center overflow-hidden rounded-md">
            {brandingLogo ? (
              <img
                crossOrigin="anonymous"
                src={getCORSSafeURL(brandingLogo)}
                alt=""
                width={16}
                height={16}
                className="object-cover"
              />
            ) : (
              <div className="flex items-center justify-center">
                <AppLogo width={16} height={16} />
              </div>
            )}
          </div>
          <span className="min-w-0 flex-1 truncate text-left text-xs text-foreground">
            {organizationLine}
          </span>
        </div>
      </div>
    </div>
  );
}
